import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';
import Spinner from '@atlaskit/spinner';

import { optInToBeta } from 'src/redux/search/actions';
import { SearchState } from 'src/redux/search/reducer';
import { getTargetUser } from 'src/selectors/user-selectors';
import { BucketState } from 'src/types/state';

import EmptyState from '../empty-state/empty-state';
import emptyImgUrl from '../search-empty.svg';

import OptInError from './opt-in-error';
import messages from './opt-in.i18n';
import * as styles from './opt-in.style';

export const OptInSourceView = () => {
  const dispatch = useDispatch();

  const account = useSelector(getTargetUser);
  const { isOptInLoading, isOptInSuccess, optInFailed } = useSelector<
    BucketState,
    SearchState
  >(state => state.search);
  const onOptIn = () => dispatch(optInToBeta(account!));

  return (
    <EmptyState
      headingMessage={messages.enableHeader}
      imageSrc={emptyImgUrl}
      descriptionMessage={messages.enableDescription}
    >
      {!isOptInSuccess && (
        <styles.OptInButtonContainer>
          <CustomThemeButton
            onClick={onOptIn}
            appearance="primary"
            iconAfter={isOptInLoading ? <Spinner size="small" /> : undefined}
            isDisabled={isOptInLoading}
          >
            <FormattedMessage {...messages.enable} />
          </CustomThemeButton>
        </styles.OptInButtonContainer>
      )}
      <OptInError showError={optInFailed} />
    </EmptyState>
  );
};
